// # Task calculation utilities
import { addDays, startOfDay } from 'date-fns';

// # Calculate dates based on plan and starting date
export const calculateDates = (tasks, plan, startDate = new Date()) => {
  // # Convert startDate to start of day and ensure it's a Date object
  const baseDate = startOfDay(new Date(startDate));
  
  // # Create a map of day numbers to dates
  const dayMap = {};
  
  // # First pass: find all unique days for the selected plan
  tasks.forEach(task => {
    if (task.plan === plan && task.day) {
      const dayNumber = parseInt(task.day);
      if (!isNaN(dayNumber) && !dayMap[dayNumber]) {
        // # Calculate date for this day (day 1 = startDate, day 2 = startDate + 1, etc.)
        dayMap[dayNumber] = addDays(baseDate, dayNumber - 1);
      }
    }
  });
  
  // # Second pass: update tasks with calculated dates
  return tasks.map(task => {
    if (task.plan === plan && task.day && dayMap[parseInt(task.day)]) {
      return {
        ...task,
        date: dayMap[parseInt(task.day)].toISOString()
      };
    }
    return task;
  });
};
